import { createContext, useContext } from "react"

export type DateRange = [string, string]

interface DateRangeContextValue {
  dateRange: DateRange
}

const DateRangeContext = createContext<DateRangeContextValue | null>(null)

export const useDateRange = () => {
  const context = useContext(DateRangeContext)
  if (!context) {
    throw new Error("useDateRange must be used within DashboardWidgetSection")
  }
  return context
}

export { DateRangeContext }
